<script lang="ts">
	import type { ComponentProps } from "svelte";
	import { Country } from "@core/schema/Country.js";
	import { countryNameMap } from "@core/schema/names/countryNameMap.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import Select from "./form/Select.svelte";
	import SelectDivider from "./form/SelectDivider.svelte";

	const { tenant, countrySettings } = getGlobalTemplateProps();
	let {
		value = $bindable(),
		/* eslint-disable prefer-const */
		...props
		/* eslint-enable prefer-const */
	}: Omit<ComponentProps<typeof Select>, "children"> = $props();

	const pinnedCountries = [Country.Czechia, Country.Slovakia].filter((country) =>
		countrySettings.some((cs) => cs.country === country),
	);

	const notPinnedCountriesToShow = $derived(
		countrySettings
			.filter((country) => !pinnedCountries.includes(country.country))
			.sort((a, b) => countryNameMap[a.country][tenant.locale].localeCompare(countryNameMap[b.country][tenant.locale])),
	);
</script>

<Select bind:value {...props}>
	{#each pinnedCountries as country (country)}
		<option value={country}>{countryNameMap[country][tenant.locale]}</option>
	{/each}
	{#if pinnedCountries.length > 0 && notPinnedCountriesToShow.length > 0}
		<SelectDivider />
	{/if}
	{#each notPinnedCountriesToShow as { country } (country)}
		<option value={country}>{countryNameMap[country][tenant.locale]}</option>
	{/each}
</Select>
